const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
const CANCEL_ORDER = 'CANCEL_ORDER';
const COMPLETE_ORDER = 'COMPLETE_ORDER';
const IN_PROGRESS_ORDER = 'IN_PROGRESS_ORDER';
const PENDING_ORDER = 'PENDING_ORDER';
// const LIVE_ORDER = 'LIVE_ORDER';
const FETCH_ORDERS = 'FETCH_ORDERS';
const VIEW_ORDER_DETAILS = 'VIEW_ORDER_DETAILS';
const CLOSE_DETAILS = 'CLOSE_DETAILS';

const UPDATE_ORDER_STATUS_SUCCESS = 'UPDATE_ORDER_STATUS_SUCCESS';
const UPDATE_ORDER_STATUS_FAILURE = 'UPDATE_ORDER_STATUS_FAILURE';
const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE';
const COMPLETE_ORDER_SUCCESS = 'COMPLETE_ORDER_SUCCESS';
const COMPLETE_ORDER_FAILURE = 'COMPLETE_ORDER_FAILURE';
const IN_PROGRESS_ORDER_SUCCESS = 'IN_PROGRESS_ORDER_SUCCESS';
const IN_PROGRESS_ORDER_FAILURE = 'IN_PROGRESS_ORDER_FAILURE';
const PENDING_ORDER_SUCCESS = 'PENDING_ORDER_SUCCESS';
const PENDING_ORDER_FAILURE = 'PENDING_ORDER_FAILURE';
// const LIVE_ORDER_SUCCESS
// const LIVE_ORDER_FAILURE
const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';
const VIEW_ORDER_DETAILS_SUCCESS = 'VIEW_ORDER_DETAILS_SUCCESS';
const VIEW_ORDER_DETAILS_FAILURE = 'VIEW_ORDER_DETAILS_FAILURE';

// CLOSE_DETAILS,

export {
    UPDATE_ORDER_STATUS,
    CANCEL_ORDER,
    COMPLETE_ORDER,
    IN_PROGRESS_ORDER,
    PENDING_ORDER,
    FETCH_ORDERS,
    VIEW_ORDER_DETAILS,
    CLOSE_DETAILS,

    // constants for success and failure actions of async operations
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_FAILURE,
    CANCEL_ORDER_SUCCESS,
    CANCEL_ORDER_FAILURE,
    COMPLETE_ORDER_SUCCESS,
    COMPLETE_ORDER_FAILURE,
    IN_PROGRESS_ORDER_SUCCESS,
    IN_PROGRESS_ORDER_FAILURE,
    PENDING_ORDER_SUCCESS,
    PENDING_ORDER_FAILURE,
    FETCH_ORDERS_SUCCESS,
    FETCH_ORDERS_FAILURE,
    VIEW_ORDER_DETAILS_SUCCESS,
    VIEW_ORDER_DETAILS_FAILURE
};